export const LOAD_CATEGORIES_WITH_PRODUCTS = 'LOAD_CATEGORIES_WITH_PRODUCTS'
export const SET_LOADING = 'SET_LOADING'
export const SET_CURRENT_SHOP = 'SET_CURRENT_SHOP'
export const SET_ERROR = 'SET_ERROR'
export const SET_PAYMENT_METHODS = 'SET_PAYMENT_METHODS'
export const SET_CUSTOMERS = 'SET_CUSTOMERS'

// Multi-cart mutations
export const SET_ACTIVE_CART_INDEX = 'SET_ACTIVE_CART_INDEX'
export const ADD_CART = 'ADD_CART'
export const REMOVE_CART = 'REMOVE_CART'
export const SET_CART_ITEMS = 'SET_CART_ITEMS'
export const ADD_TO_CART = 'ADD_TO_CART'
export const UPDATE_CART_ITEM = 'UPDATE_CART_ITEM'
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'
export const CLEAR_ACTIVE_CART = 'CLEAR_ACTIVE_CART'
export const CLEAR_ALL_CARTS = 'CLEAR_ALL_CARTS'
export const REMOVE_ITEM_FROM_ALL_CARTS = 'REMOVE_ITEM_FROM_ALL_CARTS'
export const SET_SELECTED_CLIENT = 'SET_SELECTED_CLIENT'
export const SET_PRODUCTS = 'SET_PRODUCTS'
